import { Divider } from 'antd';

const Alphanine = () => {
  return (
    <div className="bg-[#f3f3f3] p-4 md:p-8 pt-4 rounded-md">
      <Divider />
      <p className="m-2 font-bold">
        Important Safety Information: ALPHANATE® (antihemophilic factor/von Willebrand factor
        complex [human])
      </p>

      <p className="m-2">
        ALPHANATE is contraindicated in patients who have manifested life-threatening immediate
        hypersensitivity reactions, including anaphylaxis, to the product or its components.
      </p>

      <p className="m-2">
        Anaphylaxis and severe hypersensitivity reactions are possible with ALPHANATE. Discontinue
        use of ALPHANATE if hypersensitivity symptoms occur, and initiate appropriate treatment.
      </p>

      <p className="m-2">
        Development of procoagulant activity-neutralizing antibodies (inhibitors) has been detected
        in patients receiving FVIII-containing products. Carefully monitor patients treated with AHF
        products for the development of FVIII inhibitors by appropriate clinical observations and
        laboratory tests.
      </p>

      <p className="m-2">
        Thromboembolic events have been reported with AHF/VWF complex (human) in VWD patients,
        especially in the setting of known risk factors.
      </p>

      <p className="m-2">
        Intravascular hemolysis may occur with infusion of large doses of AHF/VWF complex (human).
      </p>

      <p className="m-2">
        Rapid administration of a FVIII concentrate may result in vasomotor reactions.
      </p>

      <p className="m-2">
        Because ALPHANATE is made from human plasma, it may carry a risk of transmitting infectious
        agents, eg, viruses, the variant Creutzfeldt-Jakob disease (vCJD) agent, and, theoretically,
        the Creutzfeldt-Jakob disease (CJD) agent, despite steps designed to reduce this risk.
      </p>

      <p className="m-2">
        Monitor for development of FVIII and VWF inhibitors. Perform appropriate assays to determine
        if FVIII and/or VWF inhibitor(s) are present if bleeding is not controlled with expected
        dose of ALPHANATE.
      </p>

      <p className="m-2">
        The most frequent adverse drug reactions reported with ALPHANATE in &gt;1% of infusions were
        pruritus, headache, back pain, paresthesia, respiratory distress, facial edema, pain, rash,
        and chills.
      </p>

      <div>
        <p className="m-2">
          <b>
            Please see&nbsp;
            <a
              target="_blank"
              href="/ALPHANATE-Prescribing-Information.pdf"
              className="text-blue-500 hover:underline"
            >
              ALPHANATE full Prescribing Information
            </a>
            &nbsp;for complete prescribing details.
          </b>
        </p>
        <p className="m-2">
          <b>
            You are encouraged to report negative side effects of prescription drugs to the FDA.
            Visit&nbsp;
            <a
              target="_blank"
              href="http://www.fda.gov/medwatch"
              className="text-blue-500 hover:underline"
            >
              www.fda.gov/medwatch
            </a>
            &nbsp;or call 1-800-FDA-1088.
          </b>
        </p>
      </div>

      <Divider />

      <p className="m-2 font-bold">
        Important Safety Information: AlphaNine® SD (coagulation factor IX [human])
      </p>

      <p className="m-2">
        AlphaNine SD is made from human plasma. Plasma products carry a risk of transmitting
        infectious agents, including viruses, and theoretically, the Creutzfeldt-Jakob disease (CJD)
        agent, despite steps designed to reduce this risk.
      </p>

      <p className="m-2">
        Incidences of thrombosis or disseminated intravascular coagulation (DIC) have been reported
        following administration of Factor IX Complex concentrates which contain high amounts of
        Factor II, VII and X. AlphaNine SD contains low, nontherapeutic levels of Factor II, VII and
        X.
      </p>

      <p className="m-2">
        Following administration in surgery patients and individuals with known liver disease, the
        physician should closely observe the patient for signs and symptoms of potential
        disseminated intravascular coagulation.
      </p>

      <p className="m-2">
        Allergic type hypersensitivity reactions, including anaphylaxis, have been reported for all
        factor IX products. The administration of plasma preparations may cause allergic reactions,
        mild chills, nausea or stinging at the infusion site.
      </p>

      <p className="m-2">
        Nephrotic syndrome has been reported following attempted immune tolerance induction with
        factor IX products in hemophilia B patients with factor IX inhibitors and a history of
        severe allergic reactions to Factor IX.
      </p>

      <p className="m-2">
        In order to minimize the possibility of thrombogenic complications, dosing guidelines should
        be strictly followed.
      </p>

      <p className="m-2">
        AlphaNine SD should not be administered at a rate exceeding 10 mL/ minute. Rapid
        administration may result in vasomotor reactions.
      </p>

      <div>
        <p className="m-2">
          <b>
            Please see&nbsp;
            <a
              target="_blank"
              href="/AlphaNine-Prescribing-Information.pdf"
              className="text-blue-500 hover:underline"
            >
              AlphaNine full Prescribing Information
            </a>
            &nbsp;for complete prescribing details.
          </b>
        </p>
        <p className="m-2">
          <b>
            You are encouraged to report negative side effects of prescription drugs to the FDA.
            Visit&nbsp;
            <a
              target="_blank"
              href="http://www.fda.gov/medwatch"
              className="text-blue-500 hover:underline"
            >
              www.fda.gov/medwatch
            </a>
            &nbsp;or call 1-800-FDA-1088.
          </b>
        </p>
      </div>
    </div>
  );
};

export default Alphanine;
